import { createSlice } from '@reduxjs/toolkit';
import { handleLoginStepResult } from './auth';
import { logout } from '@cc/common';

const slice = createSlice({
    name: 'userEnrollmentWizard',
    initialState: {
        userEnrollmentToken: null,
        finalResult: null,
    },
    reducers: {
        setUserEnrollmentToken(state, action) {
            state.userEnrollmentToken = action.payload;
        },
        setFinalResult(state, action) {
            state.finalResult = action.payload;
        },
    },
});

export const { setUserEnrollmentToken, setFinalResult } = slice.actions;

export default slice.reducer;

// Thunks (side-effects)

export const completeUserEnrollment = () => async (dispatch, getState) => {
    const { finalResult } = getState().userEnrollmentWizard;
    handleLoginStepResult(dispatch, getState, finalResult);
};

export const exitEnrollment = () => async (dispatch) => {
    await dispatch(setUserEnrollmentToken(null));
    await dispatch(logout());
    // After invalidating the userEnrollmentToken, we need to redirect the user back to SSOPortal to force them to log in again.
    window.location = window.environment.SSO_PORTAL_URL
}
